import layout from '@/layout'

export default {
  path: '/user',
  component: layout,
  redirect: '/user/userWinner',
  name: 'userWinner',
  meta: {
    title: 'user',
    icon: 'admin'
  },
  children: [
    {
      path: '/user/userWinner',
      name: 'userWinner',
      component: () => import('@/views/user/user-winner/index.vue'),
      meta: {
        title: 'userWinner',
        icon: 'admin'
      }
    }
  ]
}
